import { Link } from "react-router-dom";

const links = [
  { name: "Home", href: "/" },
  { name: "Photos", href: "/photos" },
  { name: "Illustrations", href: "/illustrations" },
  { name: "Videos", href: "/videos" },
  { name: "Blog", href: "/blog" },
  { name: "Favorites", href: "/favorites" },
  { name: "FAQ", href: "/faq" },
];

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        {/* nav row */}
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-12">
          {links.map((l) => (
            <Link
              key={l.name}
              to={l.href}
              className="inline-flex items-center min-h-[44px] px-3 text-sm font-semibold text-gray-500 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
            >
              {l.name}
            </Link>
          ))}
        </nav>

        {/* bottom bar */}
        <div className="mt-12 pt-6 border-t border-gray-100 dark:border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            &copy; {new Date().getFullYear()}{' '}
            <a
              href="https://faysalkhan.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center min-h-[44px] px-2 font-medium text-gray-600 dark:text-gray-300 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
            >
              Faysal Khan
            </a>
            . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
